var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C27.665 0 35.5 7.83502 35.5 17.5C35.5 27.165 27.665 35 18 35C8.33502 35 0.5 27.165 0.5 17.5C0.5 7.83502 8.33502 0 18 0ZM18 2.91699C9.946 2.91717 3.41699 9.44596 3.41699 17.5C3.41708 25.554 9.94605 32.0828 18 32.083C26.0541 32.083 32.5839 25.5541 32.584 17.5C32.584 9.44585 26.0542 2.91699 18 2.91699ZM25.6602 10.6982C26.1952 10.0963 27.1168 10.0422 27.7188 10.5771C28.2744 11.0711 28.3635 11.894 27.9531 12.4912L27.8398 12.6357L16.1738 25.7607C15.6562 26.343 14.7828 26.4088 14.1855 25.9404L14.0527 25.8232L8.21875 19.9893C7.64978 19.4198 7.64977 18.4971 8.21875 17.9277C8.74446 17.402 9.57244 17.3608 10.1445 17.8057L10.2812 17.9277L15.0205 22.666L25.6602 10.6982Z",
    fill: "#00AD3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleGreen);
export default __webpack_public_path__ + "static/media/checkCircleGreen.282c93b75440693fc0c4c5c64076bedb.svg";
export { ForwardRef as ReactComponent };